import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'
import { ProductAvailableFieldModel, ProductModel } from 'Pages/orders'

type ProductState = {
	fields: ProductAvailableFieldModel[]
	products: ResponseCatalog<ProductModel>
	product: ProductModel
	requestParams: RequestParams
	productGroups: ResponseCatalog<ShortDataModel>
}

const productInitialState: ProductState = {
	fields: [],
	products: new ResponseCatalog(),
	product: new ProductModel(),
	requestParams: new RequestParams(1, 30),
	productGroups: new ResponseCatalog(),
}

export namespace ProductNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
	}>
	export type SetAll = PayloadAction<ResponseCatalog<ProductModel>>
	export type SetParams = PayloadAction<RequestParams>
	export type GetFields = PayloadAction
	export type SetFields = PayloadAction<ProductAvailableFieldModel[]>

	export type GetOne = PayloadAction<number>
	export type SetOne = PayloadAction<ProductModel>

	export type UpdateOne = PayloadAction<{
		id: number
		product: ProductModel
		deleteImageUrl?: string
	}>
	export type CreateOne = PayloadAction<ProductModel>
	export type DeleteOne = PayloadAction<ProductModel>

	export type RestoreOne = PayloadAction<ProductModel>

	export type GetProductGroups = PayloadAction
	export type SetProductGroups = PayloadAction<ResponseCatalog<ShortDataModel>>
	export type SetOneUpdate = PayloadAction<ProductModel>
}

export const productSlice = createSlice({
	name: 'product',
	initialState: productInitialState,
	reducers: {
		getAll: (state, action: ProductNS.GetAll) => {},
		setAll: (state, action: ProductNS.SetAll) => {
			state.products = action.payload
		},
		setParams: (state, action: ProductNS.SetParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.products = new ResponseCatalog<ProductModel>()
			state.requestParams = new RequestParams()
		},
		getFields: (state, action: ProductNS.GetFields) => {},
		setFields: (state, action: ProductNS.SetFields) => {
			state.fields = action.payload
		},
		getOne: (state, action: ProductNS.GetOne) => {},
		setOne: (state, action: ProductNS.SetOne) => {
			state.product = action.payload
		},
		clearOne: (state) => {
			state.product = new ProductModel()
		},

		updateOne: (state, action: ProductNS.UpdateOne) => {},
		createOne: (state, action: ProductNS.CreateOne) => {},
		deleteOne: (state, action: ProductNS.DeleteOne) => {},
		restoreOne: (state, action: ProductNS.RestoreOne) => {},
		getProductGroups: (state, action: ProductNS.GetProductGroups) => {},
		setProductGroups: (state, action: ProductNS.SetProductGroups) => {
			state.productGroups = action.payload
		},
		setOneUpdate: (state, action: ProductNS.SetOneUpdate) => {
			const { id } = action.payload
			state.products.entries = state.products.entries.map((item: ProductModel): ProductModel => {
				if (item.id === id) {
					return action.payload
				}
				return item
			})
		},
	},
})
